<template>
  <footer class="footer mt-3">
    <div class="row footer_logos">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-4 mb-3 mb-md-0 col-lg-3 col-xl-3 dfg_logo">
            <a href="http://www.dfg.de/" target="_blank">
              <img src="dfg_logo_schriftzug_blau.png" width="215" />
            </a>
          </div>
          <div class="col-12 col-md-4 mb-3 mb-md-0 col-lg-3 col-xl-3 bsb_logo">
            <a href="https://www.bsb-muenchen.de/" target="_blank">
              <img src="bsb_logo.svg" width="150" />
            </a>
          </div>
          <div class="col-12 col-md-4 col-lg-3 col-xl-3 logo_slub">
            <a href="https://www.slub-dresden.de/" target="_blank">
              <img src="Logo_SLUB_2012.svg" width="120" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row footer_links">
      <div class="container">
        <div class="row footer_links_row ">
          <div
            class="datenschutz col-12 col-md-4 mb-3 mb-md-0 col-lg-3 col-xl-3"
          >
            <router-link to="/datenschutz">Datenschutzerklärung</router-link>
          </div>
          <div class="impressum col-12 col-md-4 mb-3 mb-md-0 col-lg-3 col-xl-3">
            <router-link to="/impressum">Impressum</router-link>
          </div>
          <div
            class="barrierefreiheitserklärung col-12 col-md-4 col-lg-3 col-xl-3"
          >
            <router-link to="/barrierefreiheit">Barrierefreiheit</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FleischmannFooter",
  data() {
    return {};
  },
};
</script>

<style scoped>
.dfg_logo {
  display: flex;
  justify-content: center;
}
.bsb_logo {
  display: flex;
  justify-content: center;
}
.logo_slub {
  display: flex;
  justify-content: center;
}
.footer_logos {
  background-color: #b6b6b6;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  height: max-content;
}
.footer_links {
  background-color: #5d5d5d;
  color: white;
  padding-bottom: 6rem;
  padding-top: 3rem;
  height: 75%;
}
a {
  color: white;
}
.barrierefreiheitserklärung {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px !important;
}
.datenschutz {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 5px !important;
}
.impressum {
  display: flex;
  justify-content: center;
  margin-bottom: 5px !important;
}
footer {
  position: relative;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.footer_links_row {
  justify-content: space-between;
}
@media (max-width: 768px) {
  .footer_links_row {
    justify-content: center;
  }
  .col {
    align-self: center;
  }
  .barrierefreiheitserklärung {
    display: block;
  }
  .datenschutz {
    display: block;
  }
  .impressum {
    display: block;
  }
  .footer_links {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
/* @media (max-width: 600px) {
  footer {
    position: relative;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
} */
</style>
